'use client'

import React from 'react'
import styles from './styles.module.css'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'
import { convertRichTextToHTML } from '@/components/StrapiContentRenderer'

interface TwoColumnsParagraphsData {
  thesis?: string | any
  description?: string | any
}

interface TwoColumnsParagraphsProps {
  data: TwoColumnsParagraphsData
}

const processText = (text: string | any): string => {
  if (!text) return ''
  
  if (typeof text === 'string') {
    return processStrapiTextTags(text)
  }
  
  if (Array.isArray(text)) {
    const html = convertRichTextToHTML(text)
    return processStrapiTextTags(html)
  }
  
  return processStrapiTextTags(String(text))
}

const processTextWithLineBreaks = (text: string | any): string => {
  if (!text) return ''
  
  let processed = ''
  if (typeof text === 'string') {
    // Заменяем \n\n на параграфы, \n на <br>
    processed = text.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br>')
    // Оборачиваем в <p> если есть контент
    if (processed) {
      processed = `<p>${processed}</p>`
    }
    return processStrapiTextTags(processed)
  }
  
  if (Array.isArray(text)) {
    const html = convertRichTextToHTML(text)
    return processStrapiTextTags(html)
  }
  
  return processStrapiTextTags(String(text))
}

const TwoColumnsParagraphs: React.FC<TwoColumnsParagraphsProps> = ({ data }) => {
  const thesis = processTextWithLineBreaks(data.thesis)
  const description = processText(data.description)

  if (!thesis && !description) {
    return null
  }

  return (
    <section className={styles.twoColumnsParagraphs}>
      {thesis && (
        <div 
          className={styles.thesis}
          dangerouslySetInnerHTML={{ __html: thesis }}
        />
      )}
      {description && (
        <div 
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </section>
  )
}

TwoColumnsParagraphs.displayName = 'TwoColumnsParagraphs'

export default TwoColumnsParagraphs

